import { useMapContext } from 'widgets/earthMap/contexts/mapContext';
import { useEffect, useMemo } from 'react';
import { CLUSTERED_SELECTED_FEATURE_PROPERTY } from 'widgets/earthMap/constants/mapConstants';
import IColorInfo from 'widgets/earthMap/interfaces/IColorInfo';

export default function useClusterColor({ layerName, sourceName }) {
	const [{ map, min, max, isClustered, clusterColorInfo }] = useMapContext();

	const sortedColorInfo = useMemo(() => {
		const rtn = [...clusterColorInfo].sort((a: IColorInfo, b: IColorInfo) => {
			if (a.maxValue < b.maxValue) return -1;
			else if (a.maxValue > b.maxValue) return 1;
			else return 0;
		});
		return rtn;
	}, [clusterColorInfo]);

	//CIRCLE color
	useEffect(() => {
		if (!map) return;
		const source = map.getSource(sourceName);
		if (!source) return;
		const layer = map.getLayer(layerName);
		if (!layer) return;
		map.setPaintProperty(layerName, 'circle-color', [
			'step',
			['get', CLUSTERED_SELECTED_FEATURE_PROPERTY],
			sortedColorInfo[0].color ?? 'blue', //info[0].color if less than info[1].min
			sortedColorInfo[1].minValue,
			sortedColorInfo[1].color ?? 'blue', //info[1].color if less than info[2].min
			sortedColorInfo[2].minValue,
			sortedColorInfo[2].color ?? 'blue', //info[2].color if less than info[3].min
			sortedColorInfo[3].minValue,
			sortedColorInfo[3].color ?? 'blue', //info[3].color if less than info[4].min
			sortedColorInfo[4].minValue,
			sortedColorInfo[4].color ?? 'blue', //info[4].color if less than info[5].min
			sortedColorInfo[5].minValue,
			sortedColorInfo[5].color ?? 'blue', //info[5].color
		]);
	}, [map, min, max, sourceName, layerName, isClustered, sortedColorInfo]);
}
